import {BREAK_POINTS} from '../settings';

export default function() {
  $('.js-seemore').on('click', function(e) {
    e.preventDefault();
    let $u = $(this).closest('.js-seemore-unit');
    $(this).closest('.js-wrap-seemore').fadeOut(400);

    setTimeout(function() {
      $u.find('.js-seemore-target').addClass('is-show');
      $u.find('.js-seemore-target').css('height', $u.find('.js-seemore-target-inner').height());

      if( $('.u-hidden-gtTAB').width() < BREAK_POINTS.ltSP ) {
        console.log($u.find('[data-inv]'));
        $u.find('[data-inv]').removeAttr('[data-inv]');
        $u.find('[data-inv]').addClass('is-inv');
      }
    }, 300)
  });
}
